import { render } from "./demo_offer.vue?vue&type=template&id=76ceae88&scoped=true"
const script = {}

import "./demo_offer.vue?vue&type=style&index=0&id=76ceae88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ceae88"]])

export default __exports__